module.exports = require("../../utility-bar/Popper.vue");